var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurriculumTopicStyling = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C67BC",
    d: "M25 18.75a2.5 2.5 0 0 0-2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5h-.75a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5H20a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 0 2.5 2.5h2a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 0-.5-.5h-1.5a.5.5 0 0 1-.5-.5V32.5a2.5 2.5 0 0 0-2.5-2.5 2.5 2.5 0 0 0 2.5-2.5v-5.75a.5.5 0 0 1 .5-.5H27a.5.5 0 0 0 .5-.5v-2m7.5 0a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 0 2.5 2.5h.75a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5H40a2.5 2.5 0 0 0-2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5h-2a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 0 .5-.5V32.5a2.5 2.5 0 0 1 2.5-2.5 2.5 2.5 0 0 1-2.5-2.5v-5.75a.5.5 0 0 0-.5-.5H33a.5.5 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurriculumTopicStyling);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/curriculum-topic-styling.628bd457372f817bb33e980be0ba34f9.svg";